import React, { useState, useEffect } from 'react';
import SelectBox from '../common/Selectbox';
import BankDataItem from '../common/BankDataItem';

import {
  getFlag,
  getDescription,
  country,
  paymentRail,
  getEstimatedTime,
} from '../../utils/constants';

import IconButton from '../common/IconButton';
import CopyIcon from '../../assets/images/copy.svg';
import CloseIcon from '../../assets/images/x.svg';

export default function BankAccountModal({ onClose, data }) {
  const [transferMethod, setTransferMethod] = useState(
    paymentRail(data.source_deposit_instructions.payment_rails[0])
  );

  console.log('bank data: ', data);
  const currency = data.source_deposit_instructions.currency;

  const onCopyData = async () => {
    console.log('Copiar datos');
    onClose();
  };

  return (
    <div>
      <div className="fixed z-50 inset-0 bg-black opacity-30 w-full h-full"></div>
      <div className="z-51 fixed inset-0 flex items-center justify-center">
        <div className="w-full mx-4 md:mx-0 md:w-[614px] bg-white rounded-xl shadow-xl rounded-[20px]">
          <div className="p-6 pb-4 border-b-1 border-b-[#CDD9F0] flex items-center justify-between">
            <p className="text-lg text-[#181D27] font-medium">
              Datos de cuenta
            </p>
            <button
              onClick={onClose}
              className="cursor-pointer hover:bg-[#E9EAEB]"
            >
              <img src={CloseIcon} alt="X Icon" className="w-5 h-5" />
            </button>
          </div>

          <div className="font-[poppins] p-6 space-y-4">
            <p className="text-sm text-[#535862] font-normal leading-[20px]">
              {getDescription(data.source_deposit_instructions.currency)}
            </p>
            <div className="px-6 space-x-2 bg-[#F9FAFB] border-1 border-[#E9EAEB] rounded-[10px] flex items-center">
              <div className="w-[49px] h-49px flex items-center justify-center">
                <img
                  src={getFlag(data)}
                  alt="Mexico Flag Icon"
                  className="w-[38px] h-[35px]"
                />
              </div>
              <p className="py-4 text-sm text-[#181D27] font-medium">
                Cuenta virtual Flowex{' '}
                {country(data.source_deposit_instructions.currency)}
              </p>
            </div>
            <div className="px-7 py-1 space-y-4">
              <SelectBox
                options={data.source_deposit_instructions.payment_rails.map(
                  (item) => paymentRail(item)
                )}
                selected={transferMethod}
                onChange={(val) => setTransferMethod(val)}
              />

              <BankDataItem
                title="Nombre de la cuenta"
                description={
                  currency == 'usd'
                    ? data.source_deposit_instructions.bank_beneficiary_name
                    : data.source_deposit_instructions.account_holder_name
                }
              />

              {currency != 'mxn' && currency != 'brl' && (
                <BankDataItem
                  title="Banco receptor"
                  description={data.source_deposit_instructions.bank_name}
                />
              )}

              <BankDataItem
                title="Moneda"
                description={data.source_deposit_instructions.currency.toUpperCase()}
              />

              <BankDataItem
                title={
                  currency == 'usd'
                    ? 'Número de routing'
                    : currency == 'eur'
                    ? 'IBAN'
                    : currency == 'brl'
                    ? 'Llave PIX'
                    : 'CLABE'
                }
                description={
                  currency == 'usd'
                    ? data.source_deposit_instructions.bank_routing_number
                    : currency == 'eur'
                    ? data.source_deposit_instructions.iban
                    : currency == 'brl'
                    ? (() => {
                        const br = data.source_deposit_instructions.br_code || '';
                        const m = br.match(/0014br\.gov\.bcb\.pix01(\d{2})/);
                        if (m) {
                          const len = parseInt(m[1], 10);
                          const start = br.indexOf(m[0]) + m[0].length;
                          return br.substring(start, start + len);
                        }
                        return data.source_deposit_instructions.pix_key || 'PIX pendiente';
                      })()
                    : data.source_deposit_instructions.clabe
                }
              />

              {currency == 'eur' && (
                <BankDataItem
                  title="SWIFT/BIC"
                  description={data.source_deposit_instructions.bic}
                />
              )}

              {currency == 'usd' && (
                <BankDataItem
                  title="Número de cuenta"
                  description={
                    data.source_deposit_instructions.bank_account_number
                  }
                />
              )}

              {currency != 'mxn' && currency != 'brl' && (
                <BankDataItem
                  title="Dirección del banco"
                  description={data.source_deposit_instructions.bank_address}
                />
              )}

              <BankDataItem
                title="Tiempo estimado"
                description={getEstimatedTime(currency, transferMethod)}
              />
            </div>
          </div>

          <div className="px-6 mb-6 flex float-right">
            <IconButton
              disabled={false}
              bgColor="bg-[#092F7B]"
              icon={CopyIcon}
              text="Copiar datos"
              textColor="text-[#FDFDFD]"
              onClick={onCopyData}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
